'use strict';

var util = angular.module('gymsystem.util');

util.directive('customschedule', [function() {
    return {
        restrict: 'E',
        template: '<div ng-include="\'views/workschedule.html\'"></div>',
        scope: {
            settings: '=',
            control: '=?'
        },

        link: function($scope, element) {
            $scope.scheduleTitle = 'Custom schedule';
            if($scope.settings.weekResources) {
                $scope.tabSettings = ['custom', 'weeklyScheduleResource'];
            } else {
                $scope.tabSettings = ['custom'];
            }
            var width = element.parent().parent().width();
            $scope.smallCalendar = width <= 768;

            if ($scope.smallCalendar) {
                element.addClass('small-calendar');
            }

            $scope.isSmallCalendar = function() {
                return $scope.smallCalendar;
            };

            if ($scope.control) {
                $scope.control.sizeChanged = function(width) {
                    $scope.smallCalendar = width <= 768;
                    if ($scope.smallCalendar) {
                        element.addClass('small-calendar');
                    } else {
                        element.removeClass('small-calendar');
                    }
                };
            }
        }

    };
}]);
